/**
 * Descarga un CSV en el navegador (UTF-8 con BOM para que Excel respete los acentos).
 *
 * Vive en `ui/` y no en `lib/api-*`: crear un blob y disparar un click es una acción del navegador,
 * no acceso a datos. Quien produce las filas es `lib/api-exportes.ts`.
 */
export function descargarCSV(
  nombreArchivo: string,
  cabecera: string[],
  filas: (string | number | null)[][]
): void {
  const escapar = (v: string | number | null) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const contenido = [cabecera, ...filas].map((f) => f.map(escapar).join(',')).join('\r\n');
  const blob = new Blob(['﻿' + contenido], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombreArchivo;
  a.click();
  URL.revokeObjectURL(url);
}
